import { createContext, useState, useContext, ReactNode } from 'react';

export type ExclusiveButtonId =
  | 'comments'
  | 'stickyNotes'
  | 'sections'
  | 'metadataElements'
  | 'templatesAndPlugins'
  | 'addFunnelMenu'
  | 'textNode'
  | null;

interface CanvasToolbarCtxProps {
  activeExclusiveButton: ExclusiveButtonId;
  setActiveExclusiveButton: (buttonId: ExclusiveButtonId) => void;
}

export const CanvasToolbarCtx = createContext<CanvasToolbarCtxProps>({
  activeExclusiveButton: null,
  setActiveExclusiveButton: () => {},
});

export const CanvasToolbarProvider = ({ children }: { children: ReactNode }) => {
  const [activeExclusiveButton, setActiveExclusiveButton] = useState<ExclusiveButtonId>(null);

  return (
    <CanvasToolbarCtx.Provider value={{ activeExclusiveButton, setActiveExclusiveButton }}>
      {children}
    </CanvasToolbarCtx.Provider>
  );
};

export const useCanvasToolbarContext = () => {
  const context = useContext(CanvasToolbarCtx);
  if (!context) {
    throw new Error('useCanvasToolbarContext must be used within a CanvasToolbarProvider');
  }
  return context;
};
